<template>
  <v-dialog
    v-model="incidentReportQrCodeDialog.open"
    max-width="500"
    persistent
  >
    <v-card>
      <v-card-title class="headline pb-2">
        {{ $t("medkitlogs.qrCodeDialog.title") }}
      </v-card-title>

      <v-card-text class="d-flex mr-4 px-5 pb-0">
        <v-progress-circular
          v-if="loading"
          indeterminate
          color="primary"
          class="ma-4"
        />
        <template v-else>
          <v-img :src="qrCodeData" max-width="140" v-if="qrCodeData" />
          <div class="d-flex flex-column justify-space-between ml-4">
            <p class="my-2">{{ $t("medkitlogs.qrCodeDialog.message") }}</p>
            <div class="d-flex mb-3" v-if="qrCodeData">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    medium
                    class="mr-2"
                    v-on="on"
                    @click.stop="downloadItem()"
                    >file_download</v-icon
                  >
                </template>
                <span>{{ $t("medkitlogs.qrCodeDialog.download") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon medium class="mr-2" v-on="on" @click.stop="copyItem()"
                    >content_copy</v-icon
                  >
                </template>
                <span>{{ $t("medkitlogs.qrCodeDialog.copy") }}</span>
              </v-tooltip>
            </div>
          </div>
        </template>
      </v-card-text>

      <v-card-text v-if="qrCodeData">
        <v-text-field
          v-model="qrCodeUrl"
          readonly
          dense
          hide-details
          class="flex-grow-1 mr-2"
        />
      </v-card-text>

      <v-snackbar v-model="snackbar" :timeout="2000" color="success">
        Link erfolgreich kopiert!
      </v-snackbar>

      <v-card-actions class="pa-6">
        <v-btn
          color="grey"
          outlined
          @click="incidentReportQrCodeDialog.open = false"
        >
          {{ $t("medkitlogs.back") }}
        </v-btn>
        <v-spacer />
        <v-btn color="primary" @click="$emit('printPoster')">
          <v-icon left>mdi-printer</v-icon>
          {{ $t("qrCodePoster.printPoster") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import QRCode from "qrcode";

export default {
  props: ["incidentReportQrCodeDialog", "item"],
  data: () => ({
    snackbar: false,
    loading: false,
    qrCodeKey: null,
    qrCodeData: null,
  }),
  created() {
    this.initialize();
  },
  watch: {
    async qrCodeUrl(qrUrl) {
      this.qrCodeData = qrUrl ? await QRCode.toDataURL(qrUrl) : null;
    },
  },
  computed: {
    qrCodeUrl() {
      return this.qrCodeKey
        ? `${window.location.origin}/newIncidentReport?key=${this.qrCodeKey}`
        : null;
    },
  },
  methods: {
    async initialize() {
      this.loading = true;
      try {
        const settings = await this.$store.dispatch(
          "getSettingData",
          "qrCodeKeys"
        );
        this.qrCodeKey = settings.value.incidentReport;
        if (!this.qrCodeKey) {
          await this.generateQrCode();
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    async generateQrCode() {
      const token = await this.$store.dispatch("newIncidentReportQrCode");
      this.qrCodeKey = token.token;
    },
    downloadItem() {
      const link = document.createElement("a");
      link.download = this.$t("incidentReports.qrDownloadName");
      link.href = this.qrCodeData;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    copyItem() {
      navigator.clipboard.writeText(this.qrCodeUrl).then(() => {
        this.snackbar = true;
      });
    },
  },
};
</script>
